module.exports = __webpack_public_path__ + "img/avatar.2bec2988.png";